export enum CategoryId {
    transfer = 1,
    mechanicalInspection = 2,
    'car-wash' = 3,
    refueling = 4,
    preTechnicalInspection = 5,
    longDistance = 6,
    technicalInspection = 7,
    valet = 11,
    towTruck = 16,
    whateverYouWant = 17,
    tyres = 12,
  }